import React from 'react'
import styled from 'styled-components'

interface FlexInterface {
  alignItems?: string
  children?: React.ReactNode
  gap?: number
  justifyContent?: string
  style?: object
}

function Flex(props: any) {
  const FlexElement = styled.div`
    display: flex;
    ${props.alignItems && `align-items: ${props.alignItems}`};
    ${props.gap && `gap: ${props.gap}px `};
    ${props.justifyContent && `justify-content: ${props.justifyContent}`};
  `
  return <FlexElement {...props} />
}

export default Flex
